// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   WhyHostView — base / variables / reset
   Fondo de página: #ffffff (#fff)
   Paleta:
   - Fondo general: #ffffff
   - Fondo de tarjetas/bloques: #f5ebd9 (warm sand / light beige)
   - Fondo estimado: #fae8bd (warm golden amber)
   - Azul/Teal primario: #0284a2 / #008489
   - Azul marino títulos: #0f2847 / #11233b
   - Verde positivo: #18a558 / #1ea65a
   - Rojo negativo: #e0473d
   ========================================================= */

.WhyHostBase-why-host-view-Kgk3b {
  --eh-page-bg: #ffffff;
  --eh-card-bg: #f5ebd9;
  --eh-card-bg-subtle: #f8f1e5;
  --eh-accent-gold: #fae8bd;
  --eh-navy: #0f2847;
  --eh-navy-light: #2c4260;
  --eh-teal: #0284a2;
  --eh-teal-hover: #016b84;
  --eh-teal-light: #e0f2f7;
  --eh-green: #18a558;
  --eh-green-light: #d8f3e5;
  --eh-red: #e0473d;
  --eh-text-main: #1b2436;
  --eh-text-muted: #5c687a;
  --eh-white: #ffffff;
  --eh-border: #ebdcc3;

  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background-color: #ffffff !important;
  color: #1b2436;
  color: var(--eh-text-main);
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  line-height: 1.5;
}

.WhyHostBase-why-host-view-Kgk3b *,
.WhyHostBase-why-host-view-Kgk3b *::before,
.WhyHostBase-why-host-view-Kgk3b *::after {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.WhyHostBase-why-host-view-Kgk3b button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  outline: none;
}

.WhyHostBase-why-host-view-Kgk3b a {
  color: inherit;
  text-decoration: none;
}

.WhyHostBase-why-host-view-Kgk3b a:hover {
  text-decoration: none;
}

.WhyHostBase-why-host-container-Shgar {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px;
}

@media (max-width: 768px) {
  .WhyHostBase-why-host-container-Shgar {
    padding: 0 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WhyhostView/WhyHostBase.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;8DAW8D;;AAE9D;EACE,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;;EAEpB,uGAAuG;EACvG,oCAAoC;EACpC,cAA0B;EAA1B,0BAA0B;EAC1B,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,8BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* =========================================================\n   WhyHostView — base / variables / reset\n   Fondo de página: #ffffff (#fff)\n   Paleta:\n   - Fondo general: #ffffff\n   - Fondo de tarjetas/bloques: #f5ebd9 (warm sand / light beige)\n   - Fondo estimado: #fae8bd (warm golden amber)\n   - Azul/Teal primario: #0284a2 / #008489\n   - Azul marino títulos: #0f2847 / #11233b\n   - Verde positivo: #18a558 / #1ea65a\n   - Rojo negativo: #e0473d\n   ========================================================= */\n\n.why-host-view {\n  --eh-page-bg: #ffffff;\n  --eh-card-bg: #f5ebd9;\n  --eh-card-bg-subtle: #f8f1e5;\n  --eh-accent-gold: #fae8bd;\n  --eh-navy: #0f2847;\n  --eh-navy-light: #2c4260;\n  --eh-teal: #0284a2;\n  --eh-teal-hover: #016b84;\n  --eh-teal-light: #e0f2f7;\n  --eh-green: #18a558;\n  --eh-green-light: #d8f3e5;\n  --eh-red: #e0473d;\n  --eh-text-main: #1b2436;\n  --eh-text-muted: #5c687a;\n  --eh-white: #ffffff;\n  --eh-border: #ebdcc3;\n\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  background-color: #ffffff !important;\n  color: var(--eh-text-main);\n  min-height: 100vh;\n  width: 100%;\n  overflow-x: hidden;\n  line-height: 1.5;\n}\n\n.why-host-view *,\n.why-host-view *::before,\n.why-host-view *::after {\n  box-sizing: border-box;\n}\n\n.why-host-view button {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  outline: none;\n}\n\n.why-host-view a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.why-host-view a:hover {\n  text-decoration: none;\n}\n\n.why-host-container {\n  width: 100%;\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n@media (max-width: 768px) {\n  .why-host-container {\n    padding: 0 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"why-host-view": `WhyHostBase-why-host-view-Kgk3b`,
	"why-host-container": `WhyHostBase-why-host-container-Shgar`
};
module.exports = ___CSS_LOADER_EXPORT___;
